import { z } from "zod";
import { COMMENT, CRM_OPS_STATUS, REGION_HEAD_ID, RELATIONSHIP_MANAGER_ID, SCHOOL_EDUCATOR_EMAIL, SCHOOL_EDUCATOR_MOBILE, SCHOOL_EDUCATOR_NAME } from "./consts";

// Form validation schema
export const schema = z.object({
  [REGION_HEAD_ID]: z.string().min(1, "Region Head is required"),
  [RELATIONSHIP_MANAGER_ID]: z
    .string()
    .min(1, "Relationship Manager is required"),
  [SCHOOL_EDUCATOR_NAME]: z.string().min(1, "Relationship Manager is required"),
  [SCHOOL_EDUCATOR_MOBILE]: z
    .string()
    .min(10, "This field is required")
    .regex(/^[0-9]{10}$/, "Invalid Phone Number"),
  [SCHOOL_EDUCATOR_EMAIL]: z
    .string()
    .min(1, "Please fill contact email")
    .email("This is not a valid email."),
  [CRM_OPS_STATUS]: z.enum(["Green", "Yellow", "Red"], {
    required_error: "CRM Ops Status is required",
  }),
  [COMMENT]: z.string().optional(),
});

export type FormValues = z.infer<typeof schema>;
